export const ProjectModifyTabs = {
	GENERAL: 'general',
	BUDGET: 'budget',
	PHASES_MILESTONES: 'phasesMilestones',
} as const;

export const ProjectCategory = {
	Personal: 'personal',
	Work: 'work',
};

export const ProjectModifySections = {
	TAGS: 'tags',
	ENTITIES: 'entities',
	CUSTOM_FIELDS: 'customFields',
} as const;

export const QUOTE_STATUS_COMPLETED = 'completed';
export const QUOTE_STATUS_CONFIRMED = 'approved';

export const CUSTOM_FIELD = 'custom_field';
export const CUSTOM_FIELD_CHECK_TEXT = 'custom_field_check_text';

export const QUOTE_CREATED_FROM_PROJECT_INFO_MESSAGE =
	'quote_created_from_project_info_message';

export const ALL_SUBGROUPS_SELECTED_EVENT = 'all-subgroups-selected';

export const FIELD_PROJECT_NAME = 'projectName';
export const FIELD_PROJECT_NUMBER = 'no';

export const ERROR_PROJECT_NAME_NOT_UNIQUE =
	'field "projectName" is not unique';
export const ERROR_PROJECT_NUMBER_NOT_UNIQUE = 'field "no" is not unique';

export const LANGVAR_PROJECT_NAME_NOT_UNIQUE =
	'project_modify_save_failed_unique_project_name';
export const LANGVAR_PROJECT_NUMBER_NOT_UNIQUE =
	'project_modify_save_failed_unique_project_number';
